import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Row, Col, Divider, Button, Modal, Tooltip, message } from 'antd';
import { useSelector } from 'react-redux';
import {
  getPermissionById,
  isEmpty,
  isNullObject,
  translatorVendingScheduleState,
  UpgradeDetail,
  formatMileageFromMeter,
  enumTranslator,
} from '@/utils';
import {
  PermissionButton,
  VehicleBusinessType,
  LOCALIZATION_ACCURACY,
  MapUpdaterStatusEnum,
  CLSTAG,
  ChargeStateEnum,
  ChargerConnectEnum,
} from '@/utils/constant';
import OrderList from '@/components/OrderList';
import CarouselItem from '@/components/InformationAside/carousel';
import { RootState } from '@/redux/store';
import {
  SystemState,
  VehicleState,
  VehicleScheduleState,
  VehicleTag,
} from '@/redux/type';
import { api } from '@/fetch/bussiness/api';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import Label from '@/components/Label';
import VehicleInitialDetail from '@/components/VehicleInitialDetail';
import UpdateDetailModal from '@/components/UpdateDetailModal';
import ScheduleModel from '../../../../components/ScheduleModel/SchedulemModel';
import qs from 'qs';
import {
  clstagStr,
  translateSceneSignal,
  convertSpeedMsToKmh,
} from '@/utils/util';
import SingleViewApis from '@/fetch/bussiness/singleView';
import { Method } from '@/fetch/core/util';
const requestApi = new SingleViewApis();
const Order = ({ vehicleName }: { vehicleName: string }) => {
  const singleVehiclePageInfo = useSelector(
    (state: RootState) => state.singleVehiclePageInfo
  );
  const {
    vehicleRealTimeInfo,
    alarmEventList,
    vehicleBasicInfoNew,
    scheduleRealTime,
    gpsSignal,
    sceneSignal,
  } = singleVehiclePageInfo;
  const orderPermission = getPermissionById(PermissionButton.SPV_CHECK_ORDER);
  const [orderModel, setOrderModel] = useState<boolean>(false);
  const orderConRef = useRef<HTMLDivElement>(null);
  const [isUpdateDetaiBtnVisble, setIsUpdateDetaiBtnVisble] = useState(true);
  const [isUpdateDetailModalVisible, setIsUpdateDetailModalVisible] =
    useState(false);
  const [open, setOpen] = useState(false);
  const [updateDetail, setUpdateDetail] = useState<UpgradeDetail>({});
  const [visible, setVisible] = useState(false);
  const query = qs.parse(window.location.search.split('?')[1]);
  const license = query && query.license;

  useEffect(() => {
    if (
      isNullObject(updateDetail) &&
      enumTranslator(
        'VEHICLE_STATE_ENUM',
        vehicleRealTimeInfo!.vehicleState
      ) === VehicleState.INITIALIZATION
    ) {
      requestApi
        .getMapUpdateDetail(vehicleName)
        .then((res: any) => {
          if (res.code === HttpStatusCode.Success) {
            const mapUpdateDetail =
              !isEmpty(res?.data?.appInfoList) &&
              res.data.appInfoList.filter(
                (item: any) => item.appName === 'map'
              )[0];
            if (!isNullObject(mapUpdateDetail)) {
              setUpdateDetail(mapUpdateDetail);
            }
          }
        })
        .catch((err) => {
          message.error(err);
        });
    }
  }, [vehicleRealTimeInfo!.vehicleState]);
  useEffect(() => {
    setIsUpdateDetaiBtnVisble(
      (updateDetail.progressType === MapUpdaterStatusEnum.DOWNLOADING.key ||
        updateDetail.progressType === MapUpdaterStatusEnum.UPGRADE.key) &&
        updateDetail.downloadMethod === 'FULL_SPEED'
    );
  }, [updateDetail]);
  const _InitInfoBtnPermission = getPermissionById(
    PermissionButton.VEHICLE_INIT_PREVIEW_BTN
  );
  const _MapUpdateDetailBtnPermission = getPermissionById(
    PermissionButton.MAP_UPDATE_DETAIL_BTN
  );
  const vehicleBusinessType = enumTranslator(
    'VEHICLE_BUSINESS_TYPE_ENUM',
    vehicleBasicInfoNew.businessType
  ); // 车辆类型
  const systemState = enumTranslator(
    'SYSTEM_STATE_ENUM',
    vehicleRealTimeInfo!.systemState
  ); // 系统状态
  const vehicleState = enumTranslator(
    'VEHICLE_STATE_ENUM',
    vehicleRealTimeInfo!.vehicleState
  ); // 车辆模式
  const realPower = vehicleRealTimeInfo.power
    ? vehicleRealTimeInfo.power.toFixed(0)
    : null; // 剩余电量

  // 充电状态信息
  const chargeInfo = useMemo(() => {
    const { chargeState, chargerConnect, chargeLastRecordTime, systemState } =
      vehicleRealTimeInfo || {};
    let label = '';
    if (chargeState === ChargeStateEnum.CHARGING) {
      label = '充电中';
    } else if (chargerConnect === ChargerConnectEnum.CHARGER_CONNECT) {
      label = '已插枪未充电';
    }

    return {
      labelNode: label ? <span style={{ marginLeft: 8 }}>{label}</span> : null,
      tooltip:
        systemState === SystemState.OFFLINE
          ? `最后上报：${chargeLastRecordTime}`
          : null,
      color: systemState === SystemState.OFFLINE ? '#999' : '',
    };
  }, [
    vehicleRealTimeInfo?.chargeState,
    vehicleRealTimeInfo?.chargerConnect,
    vehicleRealTimeInfo?.chargeLastRecordTime,
    vehicleRealTimeInfo?.systemState,
  ]);

  const speed = convertSpeedMsToKmh(vehicleRealTimeInfo.speed, 1); // 速度

  const [vehicleInitStatusMsg, setVeicleInitStatusMsg] = useState<any>('--');
  const stopList = (scheduleRealTime && scheduleRealTime.stopList) || [];
  const [totalTraveledMileage, setTotalTraveledMileage] = useState<any>(0);

  /**
   * 接口调用获取车辆初始状态下文案
   * @param {boolean}isVisible
   */
  const getVehicleInitStatus = async (isVisible: boolean) => {
    if (isVisible) {
      const requestParam: RequestOptions = {
        path: `${api.getVehicleLauchState}/${vehicleName}`,
      };
      const res: any = await request(requestParam);
      if (res.code == HttpStatusCode.Success) {
        setVeicleInitStatusMsg(
          (res.data && res.data.vehicleStateMessage) || '--'
        );
      } else {
        message.error(res.message || '接口请求报错');
      }
    }
  };
  const vehicleBusinessName = () => {
    if (vehicleBusinessType) {
      return `${vehicleBusinessType.slice(
        0,
        vehicleBusinessType.length - 1
      )}状态`;
    }
    return '配送状态';
  };
  const totalFinishedHover = async (isVisible: boolean) => {
    if (isVisible) {
      const res: any = await request({
        path: api.getRealtimeMileageFinished,
        method: Method.POST,
        body: {
          vehicleName,
        },
      });
      if (res.code == HttpStatusCode.Success) {
        setTotalTraveledMileage(
          (res.data && (res.data / 1000).toFixed(2)) || 0
        );
      } else {
        message.error(res.message || '接口请求报错');
      }
    }
  };

  const scheduleLabel =
    vehicleBasicInfoNew.businessType === 'VENDING'
      ? translatorVendingScheduleState(vehicleRealTimeInfo!.scheduleState)
      : vehicleRealTimeInfo!.taskType === 'DROPOFF' &&
          vehicleRealTimeInfo!.scheduleState === 'DELIVERY'
        ? VehicleScheduleState.DELIVERY
        : vehicleRealTimeInfo.taskType === 'DROPOFF' &&
            vehicleRealTimeInfo!.scheduleState === 'ALREADY'
          ? VehicleScheduleState.ALREADY
          : enumTranslator(
              'SCHEDULE_STATE_ENUM',
              vehicleRealTimeInfo!.scheduleState
            );
  const scheduleDetailPermission = getPermissionById(
    PermissionButton.SPV_SCHEDULE_DETAIL
  );
  const openMapUpdateDetail = () => {
    getMapUpdateDetail();
  };
  const getMapUpdateDetail = async () => {
    try {
      const res = await requestApi.getMapUpdateDetail(vehicleName);
      if (res.code === HttpStatusCode.Success) {
        const mapUpdateDetail =
          !isEmpty(res?.data?.appInfoList) &&
          res.data.appInfoList.filter((item: any) => item.appName === 'map')[0];
        if (!isNullObject(mapUpdateDetail)) {
          if (mapUpdateDetail.downloadMethod === 'LIMIT_SPEED') {
            message.warning('已转为静默下载');
            setOpen(false);
            setIsUpdateDetailModalVisible(false);
          } else {
            setIsUpdateDetailModalVisible(true);
          }
          setUpdateDetail(mapUpdateDetail);
        }
      } else {
        message.error(res.message);
      }
    } catch (err: any) {
      message.error(err);
    }
  };

  const confirmSilent = async () => {
    try {
      const res = await requestApi.confirmSilentUpdate(vehicleName);
      if (res.code === HttpStatusCode.Success) {
        setOpen(false);
        setIsUpdateDetailModalVisible(false);
        setIsUpdateDetaiBtnVisble(false);
        message.success('转为静默下载成功');
      } else {
        message.error('操作失败，失败原因：' + res.message);
      }
    } catch (err: any) {
      message.error('操作失败，失败原因：' + err);
    }
  };
  return (
    <div className="order">
      <div ref={orderConRef} className="order-con">
        <Row>
          <Col span={5} className="label">
            {vehicleBusinessName()}
          </Col>
          <Col span={17} className="fbox jbox cbox value">
            <span>{scheduleLabel || '--'}</span>
            <div>
              {orderPermission &&
              vehicleBasicInfoNew &&
              vehicleBasicInfoNew.businessType !==
                VehicleBusinessType.VENDING ? (
                <Button
                  size={'small'}
                  onClick={() => {
                    setOrderModel(true);
                  }}
                  style={{ marginRight: '10px' }}
                  clstag={clstagStr(CLSTAG.SinglePage_CheckOrders)}
                >
                  订单
                </Button>
              ) : (
                ''
              )}
              {scheduleDetailPermission && (
                <Button
                  size={'small'}
                  onClick={() => {
                    setVisible(true);
                  }}
                  clstag={clstagStr(CLSTAG.SinglePage_CheckSchedule)}
                >
                  调度
                </Button>
              )}
            </div>
          </Col>
        </Row>
        {!isEmpty(alarmEventList) ? (
          <CarouselItem alarmEvent={alarmEventList} vehicleName={vehicleName} />
        ) : (
          <>
            <Row>
              <Col span={5} className="label">
                事件
              </Col>
              <Col span={17} className="value">
                --
              </Col>
            </Row>
            <Row>
              <Col span={5} className="label">
                解决方案
              </Col>
              <Col span={17} className="value">
                --
              </Col>
            </Row>
          </>
        )}

        <Divider
          style={{ margin: '6px 0', borderTop: '1px solid #000000' }}
        ></Divider>
        <Row>
          <Col span={5} className="label">
            系统状态
          </Col>
          <Col span={6} className="value">
            <Tooltip
              title={
                vehicleRealTimeInfo!.systemState == 'CONNECTION_LOST' ? (
                  <Label text="" timeStamp={vehicleRealTimeInfo.recordTime} />
                ) : (
                  <>{systemState || '--'}</>
                )
              }
              trigger="hover"
            >
              {systemState || '--'}
            </Tooltip>
          </Col>
          <Col span={5} className="label">
            车辆模式
          </Col>
          <Col span={8} className="value">
            {vehicleRealTimeInfo.vehicleState ===
            VehicleState.INITIALIZATION ? (
              <Tooltip
                title={vehicleInitStatusMsg}
                trigger="hover"
                onOpenChange={(visible) => {
                  getVehicleInitStatus(visible);
                }}
              >
                {vehicleState.name || '--'}
              </Tooltip>
            ) : vehicleRealTimeInfo.systemState === SystemState.OFFLINE ? (
              `--`
            ) : vehicleRealTimeInfo.vehicleState === 'INITIALIZATION' &&
              _InitInfoBtnPermission ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {vehicleState || '--'}
                <VehicleInitialDetail vehicleName={vehicleName} />
                {_MapUpdateDetailBtnPermission && isUpdateDetaiBtnVisble && (
                  <UpdateDetailModal
                    visible={isUpdateDetailModalVisible}
                    handleClose={() => {
                      setIsUpdateDetailModalVisible(false);
                    }}
                    title={'地图升级详情'}
                    updateDetail={updateDetail}
                    open={open}
                    setOpen={setOpen}
                    getMapUpdateDetail={getMapUpdateDetail}
                    openMapUpdateDetail={openMapUpdateDetail}
                    confirmSilent={confirmSilent}
                  ></UpdateDetailModal>
                )}
              </div>
            ) : (
              vehicleState || '--'
            )}
          </Col>
        </Row>
        <Row>
          <Col span={5} className="label">
            速度
          </Col>
          <Col span={6} className="value">
            {' '}
            {speed}
          </Col>
          <Col span={5} className="label">
            里程信息
          </Col>
          <Col span={8} className="value">
            <Tooltip
              title={`整段已走里程 ${totalTraveledMileage}km`}
              trigger="hover"
              onOpenChange={(visible) => {
                totalFinishedHover(visible);
              }}
            >
              {`${formatMileageFromMeter(vehicleRealTimeInfo.currentScheduleFinishedMileage)} / ${formatMileageFromMeter(scheduleRealTime.globalMileage)} km`}
            </Tooltip>
          </Col>
        </Row>
        <Row>
          <Col span={5} className="label">
            剩余电量
          </Col>
          <Col span={19} className="fbox cbox value">
            <Tooltip title={chargeInfo.tooltip} trigger="hover">
              <Row
                style={{
                  color: chargeInfo.color,
                }}
              >
                {realPower ? <span>{realPower}%</span> : '--'}
                {realPower && (
                  <div className="battery normal">
                    <div className="inner">
                      <div
                        className={`progress  ${
                          Number(realPower) <= 20 ? 'warn' : ''
                        }`}
                        style={{ width: `${realPower}%` }}
                      ></div>
                    </div>
                  </div>
                )}
                {chargeInfo.labelNode}
              </Row>
            </Tooltip>
          </Col>
        </Row>
        <Divider
          style={{ margin: '6px 0', borderTop: '1px solid #000000' }}
        ></Divider>
        <Row>
          <Col span={5} className="label">
            北斗信号
          </Col>
          <Col span={17} className="value">
            {typeof gpsSignal === 'number' && gpsSignal >= 0 ? (
              <div>
                <img
                  src={
                    LOCALIZATION_ACCURACY[`LOCALIZATION_ACCURACY_${gpsSignal}`]
                      .icon
                  }
                ></img>
                <span
                  className={
                    LOCALIZATION_ACCURACY[`LOCALIZATION_ACCURACY_${gpsSignal}`]
                      .className
                  }
                >
                  {
                    LOCALIZATION_ACCURACY[`LOCALIZATION_ACCURACY_${gpsSignal}`]
                      .value
                  }
                </span>
              </div>
            ) : (
              <div>暂无数据</div>
            )}
          </Col>
        </Row>
        <Row>
          <Col span={5} className="label">
            定位状态
          </Col>
          <Col
            span={17}
            className="fbox cbox value"
            style={{
              color:
                typeof sceneSignal == 'number' && sceneSignal <= 3.5
                  ? 'red'
                  : '#fff',
            }}
          >
            {typeof sceneSignal == 'number'
              ? `${sceneSignal} ${translateSceneSignal(sceneSignal)}`
              : '暂无数据'}
          </Col>
        </Row>
      </div>
      <ScheduleModel
        visible={visible}
        setVisibleCb={setVisible}
        vehicleName={license}
      />
      {orderModel ? (
        <Modal
          title="订单详情"
          visible={orderModel}
          className="my-modal re-modal"
          width="1100px"
          onOk={() => setOrderModel(!orderModel)}
          onCancel={() => setOrderModel(!orderModel)}
          footer={null}
          maskClosable={false}
        >
          <OrderList
            vehicleName={vehicleName}
            visible={orderModel}
            scheduleState={vehicleRealTimeInfo!.scheduleState}
            stopList={stopList}
          ></OrderList>
        </Modal>
      ) : (
        ''
      )}
    </div>
  );
};

export default React.memo(Order);
